/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
};

export type CalendarWidget = {
  __typename?: 'CalendarWidget';
  circuitCalendarLink?: Maybe<Scalars['String']['output']>;
  circuitType: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  filterList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tournamentFilter: Scalars['String']['output'];
  tournaments?: Maybe<Array<Maybe<CalendarWidgetInfo>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CalendarWidgetInfo = {
  __typename?: 'CalendarWidgetInfo';
  endDate?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['String']['output']>;
  tournamentName?: Maybe<Scalars['String']['output']>;
  tournamentPlace?: Maybe<Scalars['String']['output']>;
  tournamentType?: Maybe<Scalars['String']['output']>;
};

export type CalendarWidgetInfoInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
  tournamentPlace?: InputMaybe<Scalars['String']['input']>;
  tournamentType?: InputMaybe<Scalars['String']['input']>;
};

export type Competition = {
  __typename?: 'Competition';
  competitionId: Scalars['ID']['output'];
  competitionJson: Scalars['AWSJSON']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  matches?: Maybe<ModelMatchConnection>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonAndTournamentType: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  sex?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentId: Scalars['ID']['output'];
  tournamentType: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type CompetitionmatchesArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type CreateCalendarWidgetInput = {
  circuitCalendarLink?: InputMaybe<Scalars['String']['input']>;
  circuitType: Scalars['String']['input'];
  filterList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tournamentFilter: Scalars['String']['input'];
  tournaments?: InputMaybe<Array<InputMaybe<CalendarWidgetInfoInput>>>;
};

export type CreateCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  competitionJson: Scalars['AWSJSON']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonAndTournamentType: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  sex?: InputMaybe<Scalars['String']['input']>;
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson: Scalars['AWSJSON']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateLiveScoreWidgetInput = {
  ctaUrls?: InputMaybe<LiveScoreWidgetCtaUrlInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  liveTournaments?: InputMaybe<Array<InputMaybe<LiveScoreWidgetTournamentInput>>>;
};

export type CreateMatchInput = {
  competitionId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['ID']['input'];
  matchLiveJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  matchScheduleJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerA1Id?: InputMaybe<Scalars['ID']['input']>;
  playerA2Id?: InputMaybe<Scalars['ID']['input']>;
  playerB1Id?: InputMaybe<Scalars['ID']['input']>;
  playerB2Id?: InputMaybe<Scalars['ID']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePlayerInput = {
  playerId: Scalars['ID']['input'];
  playerJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerStatsJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type CreateRankingInput = {
  circuitType: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
  rankingJson: Scalars['AWSJSON']['input'];
};

export type CreateRankingWidgetInput = {
  circuitType: Scalars['ID']['input'];
  rankings?: InputMaybe<Array<InputMaybe<RankingWidgetInfoInput>>>;
};

export type CreateResultsCategoriesWidgetInput = {
  adv?: InputMaybe<ResultsCategoriesWidgetAdvInput>;
  categories?: InputMaybe<Array<InputMaybe<ResultsCategoriesWidgetInfoInput>>>;
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type CreateResultsContainerWidgetInput = {
  seasonId: Scalars['ID']['input'];
  ssi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type CreateResultsWidgetInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  day: Scalars['ID']['input'];
  matches?: InputMaybe<Array<InputMaybe<ResultsWidgetMatchInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type CreateSeasonInput = {
  editorialData?: InputMaybe<Scalars['AWSJSON']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonId: Scalars['ID']['input'];
};

export type CreateTournamentDataWidgetInput = {
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  messageType: Scalars['String']['input'];
  seasonAndTournamentType: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTournamentInput = {
  circuitType: Scalars['String']['input'];
  editorialDataId: Scalars['ID']['input'];
  seasonAndTournamentType: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentJson: Scalars['AWSJSON']['input'];
  type: Scalars['ID']['input'];
};

export type DeleteCalendarWidgetInput = {
  circuitType: Scalars['String']['input'];
  tournamentFilter: Scalars['String']['input'];
};

export type DeleteCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteLiveScoreWidgetInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMatchInput = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeletePlayerInput = {
  playerId: Scalars['ID']['input'];
};

export type DeleteRankingInput = {
  circuitType: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
};

export type DeleteRankingWidgetInput = {
  circuitType: Scalars['ID']['input'];
};

export type DeleteResultsCategoriesWidgetInput = {
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type DeleteResultsContainerWidgetInput = {
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type DeleteResultsWidgetInput = {
  competitionId: Scalars['ID']['input'];
  day: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteSeasonInput = {
  seasonId: Scalars['ID']['input'];
};

export type DeleteTournamentDataWidgetInput = {
  seasonAndTournamentType: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type DeleteTournamentInput = {
  seasonAndTournamentType: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type EditorialData = {
  __typename?: 'EditorialData';
  createdAt: Scalars['AWSDateTime']['output'];
  editorialDataId: Scalars['ID']['output'];
  editorialJson: Scalars['AWSJSON']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LiveScoreWidget = {
  __typename?: 'LiveScoreWidget';
  createdAt: Scalars['AWSDateTime']['output'];
  ctaUrls?: Maybe<LiveScoreWidgetCtaUrl>;
  id: Scalars['ID']['output'];
  liveTournaments?: Maybe<Array<Maybe<LiveScoreWidgetTournament>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LiveScoreWidgetCtaUrl = {
  __typename?: 'LiveScoreWidgetCtaUrl';
  atpCalendarUrl?: Maybe<Scalars['String']['output']>;
  atpRankingUrl?: Maybe<Scalars['String']['output']>;
  wtaCalendarUrl?: Maybe<Scalars['String']['output']>;
  wtaRankingUrl?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetCtaUrlInput = {
  atpCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  atpRankingUrl?: InputMaybe<Scalars['String']['input']>;
  wtaCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  wtaRankingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetMatch = {
  __typename?: 'LiveScoreWidgetMatch';
  firstPosition?: Maybe<LiveScoreWidgetPosition>;
  resultType?: Maybe<Scalars['String']['output']>;
  roundName?: Maybe<Scalars['String']['output']>;
  secondPosition?: Maybe<LiveScoreWidgetPosition>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetMatchInput = {
  firstPosition?: InputMaybe<LiveScoreWidgetPositionInput>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  secondPosition?: InputMaybe<LiveScoreWidgetPositionInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetPlayer = {
  __typename?: 'LiveScoreWidgetPlayer';
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetPlayerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetPosition = {
  __typename?: 'LiveScoreWidgetPosition';
  isServing?: Maybe<Scalars['Boolean']['output']>;
  players?: Maybe<Array<Maybe<LiveScoreWidgetPlayer>>>;
  score?: Maybe<Array<Maybe<LiveScoreWidgetScore>>>;
};

export type LiveScoreWidgetPositionInput = {
  isServing?: InputMaybe<Scalars['Boolean']['input']>;
  players?: InputMaybe<Array<InputMaybe<LiveScoreWidgetPlayerInput>>>;
  score?: InputMaybe<Array<InputMaybe<LiveScoreWidgetScoreInput>>>;
};

export type LiveScoreWidgetScore = {
  __typename?: 'LiveScoreWidgetScore';
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  set?: Maybe<Scalars['String']['output']>;
  tie?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetScoreInput = {
  isWinner?: InputMaybe<Scalars['Boolean']['input']>;
  set?: InputMaybe<Scalars['String']['input']>;
  tie?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetTournament = {
  __typename?: 'LiveScoreWidgetTournament';
  categoryName?: Maybe<Scalars['String']['output']>;
  circuitType?: Maybe<Scalars['String']['output']>;
  competitionId?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Array<Maybe<LiveScoreWidgetMatch>>>;
  resultsUrl?: Maybe<Scalars['String']['output']>;
  seasonId?: Maybe<Scalars['String']['output']>;
  tournamentId?: Maybe<Scalars['String']['output']>;
  tournamentName?: Maybe<Scalars['String']['output']>;
  tournamentType?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetTournamentInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  circuitType?: InputMaybe<Scalars['String']['input']>;
  competitionId?: InputMaybe<Scalars['String']['input']>;
  matches?: InputMaybe<Array<InputMaybe<LiveScoreWidgetMatchInput>>>;
  resultsUrl?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['String']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
  tournamentType?: InputMaybe<Scalars['String']['input']>;
};

export type Match = {
  __typename?: 'Match';
  competition?: Maybe<Competition>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['Int']['output']>;
  matchId: Scalars['ID']['output'];
  matchLiveJson?: Maybe<Scalars['AWSJSON']['output']>;
  matchScheduleJson?: Maybe<Scalars['AWSJSON']['output']>;
  playerA1?: Maybe<Player>;
  playerA1Id?: Maybe<Scalars['ID']['output']>;
  playerA2?: Maybe<Player>;
  playerA2Id?: Maybe<Scalars['ID']['output']>;
  playerB1?: Maybe<Player>;
  playerB1Id?: Maybe<Scalars['ID']['output']>;
  playerB2?: Maybe<Player>;
  playerB2Id?: Maybe<Scalars['ID']['output']>;
  round?: Maybe<Scalars['Int']['output']>;
  roundName?: Maybe<Scalars['String']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tournamentId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ModelBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelCalendarWidgetConnection = {
  __typename?: 'ModelCalendarWidgetConnection';
  items: Array<Maybe<CalendarWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCalendarWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCalendarWidgetFilterInput>>>;
  circuitCalendarLink?: InputMaybe<ModelStringFilterInput>;
  circuitType?: InputMaybe<ModelStringFilterInput>;
  filterList?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCalendarWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCalendarWidgetFilterInput>>>;
  tournamentFilter?: InputMaybe<ModelStringFilterInput>;
};

export type ModelCompetitionConnection = {
  __typename?: 'ModelCompetitionConnection';
  items: Array<Maybe<Competition>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCompetitionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCompetitionFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  competitionJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCompetitionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCompetitionFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonAndTournamentType?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  sex?: InputMaybe<ModelStringFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentType?: InputMaybe<ModelStringFilterInput>;
  type?: InputMaybe<ModelStringFilterInput>;
};

export type ModelEditorialDataConnection = {
  __typename?: 'ModelEditorialDataConnection';
  items: Array<Maybe<EditorialData>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelEditorialDataFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelEditorialDataFilterInput>>>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  editorialJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelEditorialDataFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelEditorialDataFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelFloatFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelIDFilterInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelIDKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelIntFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelIntKeyConditionInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelLiveScoreWidgetConnection = {
  __typename?: 'ModelLiveScoreWidgetConnection';
  items: Array<Maybe<LiveScoreWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLiveScoreWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLiveScoreWidgetFilterInput>>>;
  id?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLiveScoreWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLiveScoreWidgetFilterInput>>>;
};

export type ModelMatchConnection = {
  __typename?: 'ModelMatchConnection';
  items: Array<Maybe<Match>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMatchFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMatchFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  date?: InputMaybe<ModelIntFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  matchLiveJson?: InputMaybe<ModelStringFilterInput>;
  matchScheduleJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelMatchFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMatchFilterInput>>>;
  playerA1Id?: InputMaybe<ModelIDFilterInput>;
  playerA2Id?: InputMaybe<ModelIDFilterInput>;
  playerB1Id?: InputMaybe<ModelIDFilterInput>;
  playerB2Id?: InputMaybe<ModelIDFilterInput>;
  round?: InputMaybe<ModelIntFilterInput>;
  roundName?: InputMaybe<ModelStringFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelPlayerConnection = {
  __typename?: 'ModelPlayerConnection';
  items: Array<Maybe<Player>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPlayerFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPlayerFilterInput>>>;
  not?: InputMaybe<ModelPlayerFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPlayerFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  playerJson?: InputMaybe<ModelStringFilterInput>;
  playerStatsJson?: InputMaybe<ModelStringFilterInput>;
};

export type ModelRankingConnection = {
  __typename?: 'ModelRankingConnection';
  items: Array<Maybe<Ranking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelRankingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelRankingFilterInput>>>;
  circuitType?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelRankingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelRankingFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  rank?: InputMaybe<ModelIntFilterInput>;
  rankingJson?: InputMaybe<ModelStringFilterInput>;
};

export type ModelRankingWidgetConnection = {
  __typename?: 'ModelRankingWidgetConnection';
  items: Array<Maybe<RankingWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelRankingWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelRankingWidgetFilterInput>>>;
  circuitType?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelRankingWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelRankingWidgetFilterInput>>>;
};

export type ModelResultsCategoriesWidgetConnection = {
  __typename?: 'ModelResultsCategoriesWidgetConnection';
  items: Array<Maybe<ResultsCategoriesWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelResultsCategoriesWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelResultsCategoriesWidgetFilterInput>>>;
  not?: InputMaybe<ModelResultsCategoriesWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelResultsCategoriesWidgetFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentType?: InputMaybe<ModelIDFilterInput>;
};

export type ModelResultsCategoriesWidgetPrimaryCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelResultsCategoriesWidgetPrimaryCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelResultsCategoriesWidgetPrimaryCompositeKeyInput>>>;
  eq?: InputMaybe<ModelResultsCategoriesWidgetPrimaryCompositeKeyInput>;
  ge?: InputMaybe<ModelResultsCategoriesWidgetPrimaryCompositeKeyInput>;
  gt?: InputMaybe<ModelResultsCategoriesWidgetPrimaryCompositeKeyInput>;
  le?: InputMaybe<ModelResultsCategoriesWidgetPrimaryCompositeKeyInput>;
  lt?: InputMaybe<ModelResultsCategoriesWidgetPrimaryCompositeKeyInput>;
};

export type ModelResultsCategoriesWidgetPrimaryCompositeKeyInput = {
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  tournamentType?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelResultsContainerWidgetConnection = {
  __typename?: 'ModelResultsContainerWidgetConnection';
  items: Array<Maybe<ResultsContainerWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelResultsContainerWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelResultsContainerWidgetFilterInput>>>;
  not?: InputMaybe<ModelResultsContainerWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelResultsContainerWidgetFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  ssi?: InputMaybe<ModelStringFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentType?: InputMaybe<ModelIDFilterInput>;
};

export type ModelResultsContainerWidgetPrimaryCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelResultsContainerWidgetPrimaryCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelResultsContainerWidgetPrimaryCompositeKeyInput>>>;
  eq?: InputMaybe<ModelResultsContainerWidgetPrimaryCompositeKeyInput>;
  ge?: InputMaybe<ModelResultsContainerWidgetPrimaryCompositeKeyInput>;
  gt?: InputMaybe<ModelResultsContainerWidgetPrimaryCompositeKeyInput>;
  le?: InputMaybe<ModelResultsContainerWidgetPrimaryCompositeKeyInput>;
  lt?: InputMaybe<ModelResultsContainerWidgetPrimaryCompositeKeyInput>;
};

export type ModelResultsContainerWidgetPrimaryCompositeKeyInput = {
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  tournamentType?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelResultsWidgetConnection = {
  __typename?: 'ModelResultsWidgetConnection';
  items: Array<Maybe<ResultsWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelResultsWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelResultsWidgetFilterInput>>>;
  categoryName?: InputMaybe<ModelStringFilterInput>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  date?: InputMaybe<ModelStringFilterInput>;
  day?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelResultsWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelResultsWidgetFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelResultsWidgetPrimaryCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelResultsWidgetPrimaryCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelResultsWidgetPrimaryCompositeKeyInput>>>;
  eq?: InputMaybe<ModelResultsWidgetPrimaryCompositeKeyInput>;
  ge?: InputMaybe<ModelResultsWidgetPrimaryCompositeKeyInput>;
  gt?: InputMaybe<ModelResultsWidgetPrimaryCompositeKeyInput>;
  le?: InputMaybe<ModelResultsWidgetPrimaryCompositeKeyInput>;
  lt?: InputMaybe<ModelResultsWidgetPrimaryCompositeKeyInput>;
};

export type ModelResultsWidgetPrimaryCompositeKeyInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelSeasonConnection = {
  __typename?: 'ModelSeasonConnection';
  items: Array<Maybe<Season>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSeasonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSeasonFilterInput>>>;
  editorialData?: InputMaybe<ModelStringFilterInput>;
  isCurrent?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelSeasonFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSeasonFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export enum ModelSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ModelStringFilterInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type ModelStringKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
};

export type ModelTournamentConnection = {
  __typename?: 'ModelTournamentConnection';
  items: Array<Maybe<Tournament>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTournamentDataWidgetConnection = {
  __typename?: 'ModelTournamentDataWidgetConnection';
  items: Array<Maybe<TournamentDataWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTournamentDataWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTournamentDataWidgetFilterInput>>>;
  data?: InputMaybe<ModelStringFilterInput>;
  messageType?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelTournamentDataWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTournamentDataWidgetFilterInput>>>;
  seasonAndTournamentType?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentType?: InputMaybe<ModelStringFilterInput>;
};

export type ModelTournamentFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTournamentFilterInput>>>;
  circuitType?: InputMaybe<ModelStringFilterInput>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelTournamentFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTournamentFilterInput>>>;
  seasonAndTournamentType?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  tournamentId?: InputMaybe<ModelIDFilterInput>;
  tournamentJson?: InputMaybe<ModelStringFilterInput>;
  type?: InputMaybe<ModelIDFilterInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createCalendarWidget?: Maybe<CalendarWidget>;
  createCompetition?: Maybe<Competition>;
  createEditorialData?: Maybe<EditorialData>;
  createLiveScoreWidget?: Maybe<LiveScoreWidget>;
  createMatch?: Maybe<Match>;
  createPlayer?: Maybe<Player>;
  createRanking?: Maybe<Ranking>;
  createRankingWidget?: Maybe<RankingWidget>;
  createResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  createResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  createResultsWidget?: Maybe<ResultsWidget>;
  createSeason?: Maybe<Season>;
  createTournament?: Maybe<Tournament>;
  createTournamentDataWidget?: Maybe<TournamentDataWidget>;
  deleteCalendarWidget?: Maybe<CalendarWidget>;
  deleteCompetition?: Maybe<Competition>;
  deleteEditorialData?: Maybe<EditorialData>;
  deleteLiveScoreWidget?: Maybe<LiveScoreWidget>;
  deleteMatch?: Maybe<Match>;
  deletePlayer?: Maybe<Player>;
  deleteRanking?: Maybe<Ranking>;
  deleteRankingWidget?: Maybe<RankingWidget>;
  deleteResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  deleteResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  deleteResultsWidget?: Maybe<ResultsWidget>;
  deleteSeason?: Maybe<Season>;
  deleteTournament?: Maybe<Tournament>;
  deleteTournamentDataWidget?: Maybe<TournamentDataWidget>;
  updateCalendarWidget?: Maybe<CalendarWidget>;
  updateCompetition?: Maybe<Competition>;
  updateEditorialData?: Maybe<EditorialData>;
  updateLiveScoreWidget?: Maybe<LiveScoreWidget>;
  updateMatch?: Maybe<Match>;
  updatePlayer?: Maybe<Player>;
  updateRanking?: Maybe<Ranking>;
  updateRankingWidget?: Maybe<RankingWidget>;
  updateResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  updateResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  updateResultsWidget?: Maybe<ResultsWidget>;
  updateSeason?: Maybe<Season>;
  updateTournament?: Maybe<Tournament>;
  updateTournamentDataWidget?: Maybe<TournamentDataWidget>;
};


export type MutationcreateCalendarWidgetArgs = {
  input: CreateCalendarWidgetInput;
};


export type MutationcreateCompetitionArgs = {
  input: CreateCompetitionInput;
};


export type MutationcreateEditorialDataArgs = {
  input: CreateEditorialDataInput;
};


export type MutationcreateLiveScoreWidgetArgs = {
  input: CreateLiveScoreWidgetInput;
};


export type MutationcreateMatchArgs = {
  input: CreateMatchInput;
};


export type MutationcreatePlayerArgs = {
  input: CreatePlayerInput;
};


export type MutationcreateRankingArgs = {
  input: CreateRankingInput;
};


export type MutationcreateRankingWidgetArgs = {
  input: CreateRankingWidgetInput;
};


export type MutationcreateResultsCategoriesWidgetArgs = {
  input: CreateResultsCategoriesWidgetInput;
};


export type MutationcreateResultsContainerWidgetArgs = {
  input: CreateResultsContainerWidgetInput;
};


export type MutationcreateResultsWidgetArgs = {
  input: CreateResultsWidgetInput;
};


export type MutationcreateSeasonArgs = {
  input: CreateSeasonInput;
};


export type MutationcreateTournamentArgs = {
  input: CreateTournamentInput;
};


export type MutationcreateTournamentDataWidgetArgs = {
  input: CreateTournamentDataWidgetInput;
};


export type MutationdeleteCalendarWidgetArgs = {
  input: DeleteCalendarWidgetInput;
};


export type MutationdeleteCompetitionArgs = {
  input: DeleteCompetitionInput;
};


export type MutationdeleteEditorialDataArgs = {
  input: DeleteEditorialDataInput;
};


export type MutationdeleteLiveScoreWidgetArgs = {
  input: DeleteLiveScoreWidgetInput;
};


export type MutationdeleteMatchArgs = {
  input: DeleteMatchInput;
};


export type MutationdeletePlayerArgs = {
  input: DeletePlayerInput;
};


export type MutationdeleteRankingArgs = {
  input: DeleteRankingInput;
};


export type MutationdeleteRankingWidgetArgs = {
  input: DeleteRankingWidgetInput;
};


export type MutationdeleteResultsCategoriesWidgetArgs = {
  input: DeleteResultsCategoriesWidgetInput;
};


export type MutationdeleteResultsContainerWidgetArgs = {
  input: DeleteResultsContainerWidgetInput;
};


export type MutationdeleteResultsWidgetArgs = {
  input: DeleteResultsWidgetInput;
};


export type MutationdeleteSeasonArgs = {
  input: DeleteSeasonInput;
};


export type MutationdeleteTournamentArgs = {
  input: DeleteTournamentInput;
};


export type MutationdeleteTournamentDataWidgetArgs = {
  input: DeleteTournamentDataWidgetInput;
};


export type MutationupdateCalendarWidgetArgs = {
  input: UpdateCalendarWidgetInput;
};


export type MutationupdateCompetitionArgs = {
  input: UpdateCompetitionInput;
};


export type MutationupdateEditorialDataArgs = {
  input: UpdateEditorialDataInput;
};


export type MutationupdateLiveScoreWidgetArgs = {
  input: UpdateLiveScoreWidgetInput;
};


export type MutationupdateMatchArgs = {
  input: UpdateMatchInput;
};


export type MutationupdatePlayerArgs = {
  input: UpdatePlayerInput;
};


export type MutationupdateRankingArgs = {
  input: UpdateRankingInput;
};


export type MutationupdateRankingWidgetArgs = {
  input: UpdateRankingWidgetInput;
};


export type MutationupdateResultsCategoriesWidgetArgs = {
  input: UpdateResultsCategoriesWidgetInput;
};


export type MutationupdateResultsContainerWidgetArgs = {
  input: UpdateResultsContainerWidgetInput;
};


export type MutationupdateResultsWidgetArgs = {
  input: UpdateResultsWidgetInput;
};


export type MutationupdateSeasonArgs = {
  input: UpdateSeasonInput;
};


export type MutationupdateTournamentArgs = {
  input: UpdateTournamentInput;
};


export type MutationupdateTournamentDataWidgetArgs = {
  input: UpdateTournamentDataWidgetInput;
};

export type Player = {
  __typename?: 'Player';
  createdAt: Scalars['AWSDateTime']['output'];
  playerId: Scalars['ID']['output'];
  playerJson?: Maybe<Scalars['AWSJSON']['output']>;
  playerStatsJson?: Maybe<Scalars['AWSJSON']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type Query = {
  __typename?: 'Query';
  getCalendarWidget?: Maybe<CalendarWidget>;
  getCompetition?: Maybe<Competition>;
  getCompetitionByTournament?: Maybe<ModelCompetitionConnection>;
  getEditorialData?: Maybe<EditorialData>;
  getEditorialDataById?: Maybe<ModelEditorialDataConnection>;
  getLiveScoreWidget?: Maybe<LiveScoreWidget>;
  getMatch?: Maybe<Match>;
  getMatchByDate?: Maybe<ModelMatchConnection>;
  getMatchById?: Maybe<ModelMatchConnection>;
  getMatchByRound?: Maybe<ModelMatchConnection>;
  getMatchBySeasonAndCompId?: Maybe<ModelMatchConnection>;
  getMatchCompetitionByTournament?: Maybe<ModelCompetitionConnection>;
  getPlayer?: Maybe<Player>;
  getRanking?: Maybe<Ranking>;
  getRankingWidget?: Maybe<RankingWidget>;
  getResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  getResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  getResultsWidget?: Maybe<ResultsWidget>;
  getSeason?: Maybe<Season>;
  getTournament?: Maybe<Tournament>;
  getTournamentDataWidget?: Maybe<TournamentDataWidget>;
  getTournamentsById?: Maybe<ModelTournamentConnection>;
  getTournamentsBySeasonId?: Maybe<ModelTournamentConnection>;
  listCalendarWidgets?: Maybe<ModelCalendarWidgetConnection>;
  listCompetitions?: Maybe<ModelCompetitionConnection>;
  listEditorialDatas?: Maybe<ModelEditorialDataConnection>;
  listLiveScoreWidgets?: Maybe<ModelLiveScoreWidgetConnection>;
  listMatchs?: Maybe<ModelMatchConnection>;
  listPlayers?: Maybe<ModelPlayerConnection>;
  listRankingWidgets?: Maybe<ModelRankingWidgetConnection>;
  listRankings?: Maybe<ModelRankingConnection>;
  listResultsCategoriesWidgets?: Maybe<ModelResultsCategoriesWidgetConnection>;
  listResultsContainerWidgets?: Maybe<ModelResultsContainerWidgetConnection>;
  listResultsWidgets?: Maybe<ModelResultsWidgetConnection>;
  listSeasons?: Maybe<ModelSeasonConnection>;
  listTournamentDataWidgets?: Maybe<ModelTournamentDataWidgetConnection>;
  listTournaments?: Maybe<ModelTournamentConnection>;
};


export type QuerygetCalendarWidgetArgs = {
  circuitType: Scalars['String']['input'];
  tournamentFilter: Scalars['String']['input'];
};


export type QuerygetCompetitionArgs = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetCompetitionByTournamentArgs = {
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndTournamentType?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type QuerygetEditorialDataArgs = {
  editorialDataId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetEditorialDataByIdArgs = {
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelEditorialDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetLiveScoreWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetMatchArgs = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetMatchByDateArgs = {
  date?: InputMaybe<ModelIntKeyConditionInput>;
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetMatchByIdArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetMatchByRoundArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<ModelIntKeyConditionInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetMatchBySeasonAndCompIdArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetMatchCompetitionByTournamentArgs = {
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndTournamentType?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type QuerygetPlayerArgs = {
  playerId: Scalars['ID']['input'];
};


export type QuerygetRankingArgs = {
  circuitType: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
};


export type QuerygetRankingWidgetArgs = {
  circuitType: Scalars['ID']['input'];
};


export type QuerygetResultsCategoriesWidgetArgs = {
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};


export type QuerygetResultsContainerWidgetArgs = {
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};


export type QuerygetResultsWidgetArgs = {
  competitionId: Scalars['ID']['input'];
  day: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetSeasonArgs = {
  seasonId: Scalars['ID']['input'];
};


export type QuerygetTournamentArgs = {
  seasonAndTournamentType: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type QuerygetTournamentDataWidgetArgs = {
  seasonAndTournamentType: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type QuerygetTournamentsByIdArgs = {
  filter?: InputMaybe<ModelTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerygetTournamentsBySeasonIdArgs = {
  filter?: InputMaybe<ModelTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCalendarWidgetsArgs = {
  circuitType?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ModelCalendarWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentFilter?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QuerylistCompetitionsArgs = {
  competitionId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistEditorialDatasArgs = {
  editorialDataId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelEditorialDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLiveScoreWidgetsArgs = {
  filter?: InputMaybe<ModelLiveScoreWidgetFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistMatchsArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<ModelIDKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistPlayersArgs = {
  filter?: InputMaybe<ModelPlayerFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistRankingWidgetsArgs = {
  circuitType?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelRankingWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistRankingsArgs = {
  circuitType?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<ModelIntKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistResultsCategoriesWidgetsArgs = {
  filter?: InputMaybe<ModelResultsCategoriesWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonIdTournamentType?: InputMaybe<ModelResultsCategoriesWidgetPrimaryCompositeKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistResultsContainerWidgetsArgs = {
  filter?: InputMaybe<ModelResultsContainerWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonIdTournamentType?: InputMaybe<ModelResultsContainerWidgetPrimaryCompositeKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistResultsWidgetsArgs = {
  day?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelResultsWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonIdCompetitionId?: InputMaybe<ModelResultsWidgetPrimaryCompositeKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSeasonsArgs = {
  filter?: InputMaybe<ModelSeasonFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistTournamentDataWidgetsArgs = {
  filter?: InputMaybe<ModelTournamentDataWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndTournamentType?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type QuerylistTournamentsArgs = {
  filter?: InputMaybe<ModelTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndTournamentType?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tournamentId?: InputMaybe<ModelIDKeyConditionInput>;
};

export type Ranking = {
  __typename?: 'Ranking';
  circuitType: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  player?: Maybe<Player>;
  playerId: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  rankingJson: Scalars['AWSJSON']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RankingWidget = {
  __typename?: 'RankingWidget';
  circuitType: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  rankings?: Maybe<Array<Maybe<RankingWidgetInfo>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RankingWidgetInfo = {
  __typename?: 'RankingWidgetInfo';
  nationality?: Maybe<Scalars['String']['output']>;
  playerName?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  trend?: Maybe<Scalars['String']['output']>;
};

export type RankingWidgetInfoInput = {
  nationality?: InputMaybe<Scalars['String']['input']>;
  playerName?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
};

export type ResultWidgetPlayer = {
  __typename?: 'ResultWidgetPlayer';
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['String']['output']>;
};

export type ResultWidgetPlayerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['String']['input']>;
};

export type ResultWidgetPosition = {
  __typename?: 'ResultWidgetPosition';
  isServing?: Maybe<Scalars['Boolean']['output']>;
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  players?: Maybe<Array<Maybe<ResultWidgetPlayer>>>;
  score?: Maybe<Array<Maybe<ResultWidgetScore>>>;
};

export type ResultWidgetPositionInput = {
  isServing?: InputMaybe<Scalars['Boolean']['input']>;
  isWinner?: InputMaybe<Scalars['Boolean']['input']>;
  players?: InputMaybe<Array<InputMaybe<ResultWidgetPlayerInput>>>;
  score?: InputMaybe<Array<InputMaybe<ResultWidgetScoreInput>>>;
};

export type ResultWidgetScore = {
  __typename?: 'ResultWidgetScore';
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  set?: Maybe<Scalars['String']['output']>;
  tie?: Maybe<Scalars['String']['output']>;
};

export type ResultWidgetScoreInput = {
  isWinner?: InputMaybe<Scalars['Boolean']['input']>;
  set?: InputMaybe<Scalars['String']['input']>;
  tie?: InputMaybe<Scalars['String']['input']>;
};

export type ResultsCategoriesWidget = {
  __typename?: 'ResultsCategoriesWidget';
  adv?: Maybe<ResultsCategoriesWidgetAdv>;
  categories?: Maybe<Array<Maybe<ResultsCategoriesWidgetInfo>>>;
  createdAt: Scalars['AWSDateTime']['output'];
  seasonId: Scalars['ID']['output'];
  tournamentId: Scalars['ID']['output'];
  tournamentType: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ResultsCategoriesWidgetAdv = {
  __typename?: 'ResultsCategoriesWidgetAdv';
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type ResultsCategoriesWidgetAdvInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type ResultsCategoriesWidgetInfo = {
  __typename?: 'ResultsCategoriesWidgetInfo';
  dates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ResultsCategoriesWidgetInfoInput = {
  dates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ResultsContainerWidget = {
  __typename?: 'ResultsContainerWidget';
  createdAt: Scalars['AWSDateTime']['output'];
  seasonId: Scalars['ID']['output'];
  ssi?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tournamentId: Scalars['ID']['output'];
  tournamentType: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ResultsWidget = {
  __typename?: 'ResultsWidget';
  categoryName?: Maybe<Scalars['String']['output']>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  day: Scalars['ID']['output'];
  matches?: Maybe<Array<Maybe<ResultsWidgetMatch>>>;
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ResultsWidgetMatch = {
  __typename?: 'ResultsWidgetMatch';
  firstPosition?: Maybe<ResultWidgetPosition>;
  resultType?: Maybe<Scalars['String']['output']>;
  roundName?: Maybe<Scalars['String']['output']>;
  secondPosition?: Maybe<ResultWidgetPosition>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ResultsWidgetMatchInput = {
  firstPosition?: InputMaybe<ResultWidgetPositionInput>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  secondPosition?: InputMaybe<ResultWidgetPositionInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Season = {
  __typename?: 'Season';
  createdAt: Scalars['AWSDateTime']['output'];
  editorialData?: Maybe<Scalars['AWSJSON']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  seasonId: Scalars['ID']['output'];
  tournaments?: Maybe<ModelTournamentConnection>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type SeasontournamentsArgs = {
  filter?: InputMaybe<ModelTournamentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onCreateCalendarWidget?: Maybe<CalendarWidget>;
  onCreateCompetition?: Maybe<Competition>;
  onCreateEditorialData?: Maybe<EditorialData>;
  onCreateLiveScoreWidget?: Maybe<LiveScoreWidget>;
  onCreateMatch?: Maybe<Match>;
  onCreatePlayer?: Maybe<Player>;
  onCreateRanking?: Maybe<Ranking>;
  onCreateRankingWidget?: Maybe<RankingWidget>;
  onCreateResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  onCreateResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  onCreateResultsWidget?: Maybe<ResultsWidget>;
  onCreateSeason?: Maybe<Season>;
  onCreateTournament?: Maybe<Tournament>;
  onCreateTournamentDataWidget?: Maybe<TournamentDataWidget>;
  onDeleteCalendarWidget?: Maybe<CalendarWidget>;
  onDeleteCompetition?: Maybe<Competition>;
  onDeleteEditorialData?: Maybe<EditorialData>;
  onDeleteLiveScoreWidget?: Maybe<LiveScoreWidget>;
  onDeleteMatch?: Maybe<Match>;
  onDeletePlayer?: Maybe<Player>;
  onDeleteRanking?: Maybe<Ranking>;
  onDeleteRankingWidget?: Maybe<RankingWidget>;
  onDeleteResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  onDeleteResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  onDeleteResultsWidget?: Maybe<ResultsWidget>;
  onDeleteSeason?: Maybe<Season>;
  onDeleteTournament?: Maybe<Tournament>;
  onDeleteTournamentDataWidget?: Maybe<TournamentDataWidget>;
  onUpdateCalendarWidget?: Maybe<CalendarWidget>;
  onUpdateCompetition?: Maybe<Competition>;
  onUpdateEditorialData?: Maybe<EditorialData>;
  onUpdateLiveScoreById?: Maybe<LiveScoreWidget>;
  onUpdateLiveScoreWidget?: Maybe<LiveScoreWidget>;
  onUpdateMatch?: Maybe<Match>;
  onUpdatePlayer?: Maybe<Player>;
  onUpdateRanking?: Maybe<Ranking>;
  onUpdateRankingWidget?: Maybe<RankingWidget>;
  onUpdateRankingWidgetByCircuitType?: Maybe<RankingWidget>;
  onUpdateResultsCategoriesWidget?: Maybe<ResultsCategoriesWidget>;
  onUpdateResultsContainerWidget?: Maybe<ResultsContainerWidget>;
  onUpdateResultsWidget?: Maybe<ResultsWidget>;
  onUpdateResultsWidgetByDay?: Maybe<ResultsWidget>;
  onUpdateSeason?: Maybe<Season>;
  onUpdateTournament?: Maybe<Tournament>;
  onUpdateTournamentDataWidget?: Maybe<TournamentDataWidget>;
};


export type SubscriptiononUpdateLiveScoreByIdArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptiononUpdateRankingWidgetByCircuitTypeArgs = {
  circuitType: Scalars['ID']['input'];
};


export type SubscriptiononUpdateResultsWidgetByDayArgs = {
  competitionId: Scalars['ID']['input'];
  day: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type Tournament = {
  __typename?: 'Tournament';
  circuitType: Scalars['String']['output'];
  competitions?: Maybe<ModelCompetitionConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  editorialData?: Maybe<EditorialData>;
  editorialDataId: Scalars['ID']['output'];
  season?: Maybe<Season>;
  seasonAndTournamentType: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  tournamentId: Scalars['ID']['output'];
  tournamentJson: Scalars['AWSJSON']['output'];
  type: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type TournamentcompetitionsArgs = {
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type TournamentDataWidget = {
  __typename?: 'TournamentDataWidget';
  createdAt: Scalars['AWSDateTime']['output'];
  data?: Maybe<Scalars['AWSJSON']['output']>;
  messageType: Scalars['String']['output'];
  seasonAndTournamentType: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  tournamentId: Scalars['ID']['output'];
  tournamentType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type UpdateCalendarWidgetInput = {
  circuitCalendarLink?: InputMaybe<Scalars['String']['input']>;
  circuitType: Scalars['String']['input'];
  filterList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tournamentFilter: Scalars['String']['input'];
  tournaments?: InputMaybe<Array<InputMaybe<CalendarWidgetInfoInput>>>;
};

export type UpdateCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  competitionJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndTournamentType?: InputMaybe<Scalars['ID']['input']>;
  seasonId: Scalars['ID']['input'];
  sex?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
  tournamentType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateLiveScoreWidgetInput = {
  ctaUrls?: InputMaybe<LiveScoreWidgetCtaUrlInput>;
  id: Scalars['ID']['input'];
  liveTournaments?: InputMaybe<Array<InputMaybe<LiveScoreWidgetTournamentInput>>>;
};

export type UpdateMatchInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['ID']['input'];
  matchLiveJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  matchScheduleJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerA1Id?: InputMaybe<Scalars['ID']['input']>;
  playerA2Id?: InputMaybe<Scalars['ID']['input']>;
  playerB1Id?: InputMaybe<Scalars['ID']['input']>;
  playerB2Id?: InputMaybe<Scalars['ID']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePlayerInput = {
  playerId: Scalars['ID']['input'];
  playerJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  playerStatsJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type UpdateRankingInput = {
  circuitType: Scalars['ID']['input'];
  playerId?: InputMaybe<Scalars['ID']['input']>;
  rank: Scalars['Int']['input'];
  rankingJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type UpdateRankingWidgetInput = {
  circuitType: Scalars['ID']['input'];
  rankings?: InputMaybe<Array<InputMaybe<RankingWidgetInfoInput>>>;
};

export type UpdateResultsCategoriesWidgetInput = {
  adv?: InputMaybe<ResultsCategoriesWidgetAdvInput>;
  categories?: InputMaybe<Array<InputMaybe<ResultsCategoriesWidgetInfoInput>>>;
  seasonId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type UpdateResultsContainerWidgetInput = {
  seasonId: Scalars['ID']['input'];
  ssi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tournamentId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
};

export type UpdateResultsWidgetInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  day: Scalars['ID']['input'];
  matches?: InputMaybe<Array<InputMaybe<ResultsWidgetMatchInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateSeasonInput = {
  editorialData?: InputMaybe<Scalars['AWSJSON']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateTournamentDataWidgetInput = {
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  seasonAndTournamentType: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  tournamentId: Scalars['ID']['input'];
  tournamentType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTournamentInput = {
  circuitType?: InputMaybe<Scalars['String']['input']>;
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndTournamentType: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  tournamentId: Scalars['ID']['input'];
  tournamentJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
};

export type getCalendarWidgetQueryVariables = Exact<{
  circuitType: Scalars['String']['input'];
  tournamentFilter: Scalars['String']['input'];
}>;


export type getCalendarWidgetQuery = { __typename?: 'Query', getCalendarWidget?: { __typename?: 'CalendarWidget', circuitType: string, tournamentFilter: string, filterList?: Array<string | null> | null, circuitCalendarLink?: string | null, tournaments?: Array<{ __typename?: 'CalendarWidgetInfo', endDate?: string | null, startDate?: string | null, status?: string | null, surface?: string | null, tournamentName?: string | null, tournamentPlace?: string | null, tournamentType?: string | null, href?: string | null } | null> | null } | null };

export type getLiveScoreWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type getLiveScoreWidgetQuery = { __typename?: 'Query', getLiveScoreWidget?: { __typename?: 'LiveScoreWidget', id: string, liveTournaments?: Array<{ __typename?: 'LiveScoreWidgetTournament', competitionId?: string | null, seasonId?: string | null, categoryName?: string | null, circuitType?: string | null, tournamentName?: string | null, tournamentType?: string | null, resultsUrl?: string | null, matches?: Array<{ __typename?: 'LiveScoreWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null, secondPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null } | null> | null } | null> | null, ctaUrls?: { __typename?: 'LiveScoreWidgetCtaUrl', atpCalendarUrl?: string | null, wtaCalendarUrl?: string | null, atpRankingUrl?: string | null, wtaRankingUrl?: string | null } | null } | null };

export type getRankingWidgetQueryVariables = Exact<{
  circuitType: Scalars['ID']['input'];
}>;


export type getRankingWidgetQuery = { __typename?: 'Query', getRankingWidget?: { __typename?: 'RankingWidget', circuitType: string, rankings?: Array<{ __typename?: 'RankingWidgetInfo', rank?: number | null, trend?: string | null, nationality?: string | null, playerName?: string | null, points?: string | null } | null> | null } | null };

export type getResultsCategoriesWidgetQueryVariables = Exact<{
  tournamentId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
}>;


export type getResultsCategoriesWidgetQuery = { __typename?: 'Query', getResultsCategoriesWidget?: { __typename?: 'ResultsCategoriesWidget', tournamentType: string, categories?: Array<{ __typename?: 'ResultsCategoriesWidgetInfo', name?: string | null, dates?: Array<string | null> | null } | null> | null, adv?: { __typename?: 'ResultsCategoriesWidgetAdv', link?: string | null, image?: string | null } | null } | null };

export type getResultsContainerWidgetQueryVariables = Exact<{
  tournamentId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  tournamentType: Scalars['ID']['input'];
}>;


export type getResultsContainerWidgetQuery = { __typename?: 'Query', getResultsContainerWidget?: { __typename?: 'ResultsContainerWidget', ssi?: Array<string | null> | null } | null };

export type getResultsWidgetQueryVariables = Exact<{
  day: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
}>;


export type getResultsWidgetQuery = { __typename?: 'Query', getResultsWidget?: { __typename?: 'ResultsWidget', seasonId: string, competitionId: string, day: string, categoryName?: string | null, date?: string | null, matches?: Array<{ __typename?: 'ResultsWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null, secondPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null } | null> | null } | null };

export type LiveScoreSubcriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type LiveScoreSubcriptionSubscription = { __typename?: 'Subscription', onUpdateLiveScoreById?: { __typename?: 'LiveScoreWidget', id: string, liveTournaments?: Array<{ __typename?: 'LiveScoreWidgetTournament', competitionId?: string | null, seasonId?: string | null, categoryName?: string | null, circuitType?: string | null, tournamentName?: string | null, tournamentType?: string | null, resultsUrl?: string | null, matches?: Array<{ __typename?: 'LiveScoreWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null, secondPosition?: { __typename?: 'LiveScoreWidgetPosition', isServing?: boolean | null, players?: Array<{ __typename?: 'LiveScoreWidgetPlayer', name?: string | null, nationality?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'LiveScoreWidgetScore', isWinner?: boolean | null, set?: string | null, tie?: string | null } | null> | null } | null } | null> | null } | null> | null } | null };

export type onUpdateRankingWidgetByCircuitTypeSubscriptionVariables = Exact<{
  circuitType: Scalars['ID']['input'];
}>;


export type onUpdateRankingWidgetByCircuitTypeSubscription = { __typename?: 'Subscription', onUpdateRankingWidgetByCircuitType?: { __typename?: 'RankingWidget', circuitType: string, rankings?: Array<{ __typename?: 'RankingWidgetInfo', nationality?: string | null, playerName?: string | null, points?: string | null, rank?: number | null, trend?: string | null } | null> | null } | null };

export type onUpdateResultsWidgetByDaySubscriptionVariables = Exact<{
  day: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
}>;


export type onUpdateResultsWidgetByDaySubscription = { __typename?: 'Subscription', onUpdateResultsWidgetByDay?: { __typename?: 'ResultsWidget', seasonId: string, competitionId: string, day: string, categoryName?: string | null, date?: string | null, matches?: Array<{ __typename?: 'ResultsWidgetMatch', status?: string | null, startDate?: string | null, roundName?: string | null, resultType?: string | null, firstPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null, secondPosition?: { __typename?: 'ResultWidgetPosition', isServing?: boolean | null, isWinner?: boolean | null, players?: Array<{ __typename?: 'ResultWidgetPlayer', nationality?: string | null, name?: string | null, seed?: string | null } | null> | null, score?: Array<{ __typename?: 'ResultWidgetScore', set?: string | null, tie?: string | null, isWinner?: boolean | null } | null> | null } | null } | null> | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: Record<string, any> | undefined) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const getCalendarWidgetDocument = new TypedDocumentString(`
    query getCalendarWidget($circuitType: String!, $tournamentFilter: String!) {
  getCalendarWidget(
    circuitType: $circuitType
    tournamentFilter: $tournamentFilter
  ) {
    circuitType
    tournamentFilter
    filterList
    circuitCalendarLink
    tournaments {
      endDate
      startDate
      status
      surface
      tournamentName
      tournamentPlace
      tournamentType
      href
    }
  }
}
    `) as unknown as TypedDocumentString<getCalendarWidgetQuery, getCalendarWidgetQueryVariables>;
export const getLiveScoreWidgetDocument = new TypedDocumentString(`
    query getLiveScoreWidget {
  getLiveScoreWidget(id: "unique") {
    id
    liveTournaments {
      competitionId
      seasonId
      categoryName
      circuitType
      tournamentName
      tournamentType
      resultsUrl
      matches {
        status
        startDate
        roundName
        resultType
        firstPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
        }
        secondPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
        }
      }
    }
    ctaUrls {
      atpCalendarUrl
      wtaCalendarUrl
      atpRankingUrl
      wtaRankingUrl
    }
  }
}
    `) as unknown as TypedDocumentString<getLiveScoreWidgetQuery, getLiveScoreWidgetQueryVariables>;
export const getRankingWidgetDocument = new TypedDocumentString(`
    query getRankingWidget($circuitType: ID!) {
  getRankingWidget(circuitType: $circuitType) {
    circuitType
    rankings {
      rank
      trend
      nationality
      playerName
      points
    }
  }
}
    `) as unknown as TypedDocumentString<getRankingWidgetQuery, getRankingWidgetQueryVariables>;
export const getResultsCategoriesWidgetDocument = new TypedDocumentString(`
    query getResultsCategoriesWidget($tournamentId: ID!, $seasonId: ID!, $tournamentType: ID!) {
  getResultsCategoriesWidget(
    tournamentId: $tournamentId
    seasonId: $seasonId
    tournamentType: $tournamentType
  ) {
    categories {
      name
      dates
    }
    adv {
      link
      image
    }
    tournamentType
  }
}
    `) as unknown as TypedDocumentString<getResultsCategoriesWidgetQuery, getResultsCategoriesWidgetQueryVariables>;
export const getResultsContainerWidgetDocument = new TypedDocumentString(`
    query getResultsContainerWidget($tournamentId: ID!, $seasonId: ID!, $tournamentType: ID!) {
  getResultsContainerWidget(
    tournamentId: $tournamentId
    seasonId: $seasonId
    tournamentType: $tournamentType
  ) {
    ssi
  }
}
    `) as unknown as TypedDocumentString<getResultsContainerWidgetQuery, getResultsContainerWidgetQueryVariables>;
export const getResultsWidgetDocument = new TypedDocumentString(`
    query getResultsWidget($day: ID!, $seasonId: ID!, $competitionId: ID!) {
  getResultsWidget(day: $day, seasonId: $seasonId, competitionId: $competitionId) {
    seasonId
    competitionId
    day
    categoryName
    date
    matches {
      status
      startDate
      roundName
      resultType
      firstPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        isWinner
      }
      secondPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        isWinner
      }
    }
  }
}
    `) as unknown as TypedDocumentString<getResultsWidgetQuery, getResultsWidgetQueryVariables>;
export const LiveScoreSubcriptionDocument = new TypedDocumentString(`
    subscription LiveScoreSubcription {
  onUpdateLiveScoreById(id: "unique") {
    id
    liveTournaments {
      competitionId
      seasonId
      categoryName
      circuitType
      tournamentName
      tournamentType
      resultsUrl
      matches {
        status
        startDate
        roundName
        resultType
        firstPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
        }
        secondPosition {
          isServing
          players {
            name
            nationality
            seed
          }
          score {
            isWinner
            set
            tie
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LiveScoreSubcriptionSubscription, LiveScoreSubcriptionSubscriptionVariables>;
export const onUpdateRankingWidgetByCircuitTypeDocument = new TypedDocumentString(`
    subscription onUpdateRankingWidgetByCircuitType($circuitType: ID!) {
  onUpdateRankingWidgetByCircuitType(circuitType: $circuitType) {
    rankings {
      nationality
      playerName
      points
      rank
      trend
    }
    circuitType
  }
}
    `) as unknown as TypedDocumentString<onUpdateRankingWidgetByCircuitTypeSubscription, onUpdateRankingWidgetByCircuitTypeSubscriptionVariables>;
export const onUpdateResultsWidgetByDayDocument = new TypedDocumentString(`
    subscription onUpdateResultsWidgetByDay($day: ID!, $seasonId: ID!, $competitionId: ID!) {
  onUpdateResultsWidgetByDay(
    day: $day
    seasonId: $seasonId
    competitionId: $competitionId
  ) {
    seasonId
    competitionId
    day
    categoryName
    date
    matches {
      status
      startDate
      roundName
      resultType
      firstPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        isWinner
      }
      secondPosition {
        isServing
        players {
          nationality
          name
          seed
        }
        score {
          set
          tie
          isWinner
        }
        isWinner
      }
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateResultsWidgetByDaySubscription, onUpdateResultsWidgetByDaySubscriptionVariables>;